import { render, staticRenderFns } from "./FileAdd.vue?vue&type=template&id=32998d28&scoped=true"
import script from "./FileAdd.vue?vue&type=script&lang=js"
export * from "./FileAdd.vue?vue&type=script&lang=js"
import style0 from "./FileAdd.vue?vue&type=style&index=0&id=32998d28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32998d28",
  null
  
)

export default component.exports